"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentitySourceRequestImpulse = void 0;
var IdentitySourceRequestImpulse = /** @class */ (function () {
    function IdentitySourceRequestImpulse(identityId) {
        this.identityId = identityId;
    }
    return IdentitySourceRequestImpulse;
}());
exports.IdentitySourceRequestImpulse = IdentitySourceRequestImpulse;
//# sourceMappingURL=IdentitySourceRequestImpulse.js.map